
import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { Plus, FileText } from 'lucide-react';
import { TemplatesList } from '@/components/admin/certificates/TemplatesList';
import { CreateTemplateDialog } from '@/components/admin/certificates/CreateTemplateDialog';
import { TemplateEditor } from '@/components/admin/certificates/TemplateEditor';
import { useNavigate } from 'react-router-dom';

export function CertificatesTemplatesContent() {
  const navigate = useNavigate();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState("templates");
  
  const handleTemplateSelect = (templateId: string) => {
    setSelectedTemplate(templateId);
    setActiveTab("editor");
  };
  
  return (
    <div className="p-6 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Certificate Templates</h1>
        <div className="flex gap-2">
          <Button 
            variant="outline" 
            className="flex items-center gap-2"
            onClick={() => navigate('/certificates/reports')}
          >
            <FileText className="h-4 w-4" />
            Quarterly Reports
          </Button>
          <Button onClick={() => setIsCreateDialogOpen(true)} className="flex items-center gap-2">
            <Plus className="h-4 w-4" />
            New Template
          </Button>
        </div>
      </div>
      
      <Tabs value={activeTab} className="w-full" onValueChange={setActiveTab}>
        <TabsList className="grid grid-cols-2 w-[400px]">
          <TabsTrigger value="templates">Templates List</TabsTrigger>
          <TabsTrigger value="editor">Template Editor</TabsTrigger>
        </TabsList>
        
        <TabsContent value="templates" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle>Certificate Templates</CardTitle>
              <CardDescription>Manage your certificate templates</CardDescription>
            </CardHeader>
            <CardContent>
              <TemplatesList onTemplateSelect={handleTemplateSelect} />
            </CardContent>
          </Card>
        </TabsContent>
        
        <TabsContent value="editor" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle>Template Editor</CardTitle>
              <CardDescription>Customize your certificate template design</CardDescription>
            </CardHeader>
            <CardContent>
              {selectedTemplate ? (
                <TemplateEditor templateId={selectedTemplate} />
              ) : (
                <div className="text-center py-12">
                  <p className="text-muted-foreground mb-4">Select a template from the list to start editing</p>
                  <Button 
                    variant="outline" 
                    onClick={() => setActiveTab("templates")}
                  >
                    View Templates List
                  </Button>
                </div>
              )}
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
      
      <CreateTemplateDialog open={isCreateDialogOpen} onOpenChange={setIsCreateDialogOpen} onSuccess={(templateId) => handleTemplateSelect(templateId)} />
    </div>
  );
}
